/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */

import PaletteIconMuted from '@telus-uds/palette-koodo/build/rn/icons/Muted'
import PaletteIconUnmuted from '@telus-uds/palette-koodo/build/rn/icons/Unmuted'
const theme = {
  appearances: {},
  rules: [],
  tokens: {
    marginLeft: 16,
    marginRight: 16,
    mutedIcon: PaletteIconMuted,
    rangeBackground: 'rgba(0, 0, 0, 0)',
    thumbBackground: '#ffffff',
    thumbHeight: 8,
    thumbWidth: 8,
    trackGradientEnd: '#ffffff',
    trackGradientStart: '#ffffff',
    unmutedIcon: PaletteIconUnmuted
  }
}
export default theme
